module.exports = __webpack_public_path__ + "img/china-eastern.f1d1f826.png";